<template>
  
  <v-overlay v-model="showInfo">
    <v-card>
      <v-card-title>
        <span class="headline">Email Information</span>
      </v-card-title>
        <v-spacer></v-spacer>
        <v-card-text>
          {{JSON.stringify(email)}}
        </v-card-text>
    </v-card>
  </v-overlay>
  
  <div @click="() => {isOpen = !isOpen}" class="rounded border  px-6 py-4 ">
    <v-row>
      <v-col cols="6">
        <v-row class="text-subtitle-2">
          {{email?.message.subject}}
        </v-row>
        <v-row>
          <small>{{email?.delivery.endTime.toDate().toLocaleString('de-DE')}}</small>
        </v-row>
      </v-col>
      <v-col cols="4" class="d-flex justify-end pt-8">
        {{email?.message.date}}
      </v-col>
      <v-col cols="2" class="text-right">
        <v-btn size="28" icon class="mx-2" @click="() => {showInfo = true;}">
          <v-icon>mdi-information</v-icon>
        </v-btn>
        
        <v-icon
            class="mx-2"
            :color="email.delivery.state === 'SUCCESS' ? 'green' : email.delivery.state === 'ERROR' ? 'red' : ''">mdi-check-circle </v-icon>
        <v-icon class="mx-2">mdi-chevron-down</v-icon>
      </v-col>
    </v-row>
  </div>
  <div v-if="isOpen" class="border py-4 px-2 mb-2">
    {{email?.message.text}}
    {{email?.message.html}}
  </div>
</template>

<script setup lang="ts">
import {ref} from "vue";

const props = defineProps({
  email: { required: true }
});
const isOpen = ref(false);
const showInfo = ref(false);
const email = props.email;
</script>

<style scoped>

</style>